/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import Footer from "./Footer";
import Profile from "../../assets/img/profile-pic.png";
import Cover from "../../assets/img/cover-image.png";
import {
  FaGithub,
  FaGithubAlt,
  FaInstagram,
  FaLinkedinIn,
  FaTwitter,
} from "react-icons/fa";
import {
  HiOutlineLocationMarker,
  HiOutlinePhone,
  HiOutlineMail,
  HiOutlineCake,
} from "react-icons/hi";
import moment from "moment/moment";
import MenuButton from "./MenuButton";

const Sidebar = ({
  setThemeColor,
  setThemeRounded,
  visible,
  setVisible,
  colorTheme,
  setTheme,
}) => {
  const given = moment("2021-03-27", "YYYY-MM-DD");
  const current = moment().startOf("day");

  const years = given.diff(current, "year");
  current.add(years, "years");

  const months = given.diff(current, "months");
  current.add(months, "months");
  //console.log(Math.abs(years), Math.abs(months))

  return (
    <>
      <div className="flex flex-col justify-between items-center h-full rounded-custom">
        <div className="">
          <div className="flex flex-col relative bg-white/10 dark:bg-black/10 rounded-custom">
            <img src={Cover} alt="cover" className="w-full" />
            <img
              src={Profile}
              alt="profile"
              className="w-[100px] h-[100px] rounded-full border-8 border-black/50 dark:border-white/50 absolute top-[125px] left-1/2 transform -translate-x-1/2 -translate-y-1/2"
            />
          </div>
          <div className="flex flex-col items-center mt-[50px] mb-4">
            <h3 className="font-bold text-slate-900 dark:text-slate-50 text-2xl">
              <span className="text-skin-base">Shubham</span> Gupta
            </h3>
            <h3 className="text-slate-400 dark:text-slate-400 text-sm">
              Full Stack Developer
            </h3>
          </div>
          <div className="flex justify-center gap-4 mb-8">
            {/* <a
              href="#"
              className="text-gray-900 dark:text-slate-50 hover:text-skin-base transition-all ease-in-out delay-200"
              title="Instagram"
              target="blank"
            >
              <FaTwitter className="w-6 h-6" />
            </a>
            <a
              href="#"
              className="text-gray-900 dark:text-slate-50 hover:text-skin-base transition-all ease-in-out delay-200"
              title="Instagram"
              target="blank"
            >
              <FaInstagram className="w-6 h-6" />
            </a> */}
            <a
              href="https://github.com/Shubhamsg7"
              className="text-gray-900 dark:text-slate-50 hover:text-skin-base transition-all ease-in-out delay-200"
              title="Github"
              target="blank"
            >
              <FaGithub className="w-6 h-6" />
            </a>
            <a
              href="https://www.linkedin.com/in/shubhamsg7"
              className="text-gray-900 dark:text-slate-50 hover:text-skin-base transition-all ease-in-out delay-200"
              title="LinkedIn"
              target="blank"
            >
              <FaLinkedinIn className="w-6 h-6" />
            </a>
          </div>
          <div className="bg-slate-100/50 dark:bg-slate-800/50 p-5 m-5 rounded-custom h-[calc(100vh-550px)] overflow-y-auto">
            <div className="flex justify-between items-center mb-4">
              <h6 className="font-semibold text-md text-slate-600 dark:text-slate-300">
                Experience{" "}
              </h6>
              <h6 className="font-normal text-md text-slate-600 dark:text-slate-300">
                {Math.abs(years) + "years" + " " + Math.abs(months) + "months"}
              </h6>
            </div>
            {/* <div className="flex justify-between items-center mb-4">
              <h6 className="font-semibold text-md text-slate-600 dark:text-slate-300">
                <HiOutlineCake className="w-6 h-6" />{" "}
              </h6>
              <h6 className="font-normal text-md text-slate-600 dark:text-slate-300">
                7th September
              </h6>
            </div> */}
            <div className="flex justify-between items-center mb-4">
              <h6 className="font-semibold text-md text-slate-600 dark:text-slate-300">
                <HiOutlineLocationMarker className="w-6 h-6" />{" "}
              </h6>
              <h6 className="font-normal text-md text-slate-600 dark:text-slate-300">
                India
              </h6>
            </div>
            <div className="flex justify-between items-center mb-4">
              <h6 className="font-semibold text-md text-slate-600 dark:text-slate-300">
                <HiOutlineMail className="w-6 h-6" />{" "}
              </h6>
              <h6 className="font-normal text-md text-slate-600 dark:text-slate-300">
                workdotsg@gmail.com
              </h6>
            </div>
            {/* <div className="flex justify-between items-center">
              <h6 className="font-semibold text-md text-slate-600 dark:text-slate-300">
                <HiOutlinePhone className="w-6 h-6" />{" "}
              </h6>
              <h6 className="font-normal text-md text-slate-600 dark:text-slate-300">
                +91-7004756551
              </h6>
            </div> */}
          </div>
        </div>
        <Footer
          setThemeColor={setThemeColor}
          setThemeRounded={setThemeRounded}
          colorTheme={colorTheme}
          setTheme={setTheme}
        />
      </div>
      <MenuButton visible={visible} setVisible={setVisible} />
    </>
  );
};

export default Sidebar;
